import { DropdownMenuGroup } from '@heidi/design-system/dropdown-menu';
import { UrgencyFilterItem } from './urgency-filter-item';

export const UrgencyFilter = () => (
  <DropdownMenuGroup>
    <UrgencyFilterItem />
  </DropdownMenuGroup>
);
